import Vue from "vue";
import { BootstrapVue } from "bootstrap-vue";
import { abilitiesPlugin } from "@casl/vue";

import DashboardPlugin from "./dashboard-plugin";
import i18n from "./i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import localStorage from "./localStorage";
import ability from "./ability";
import "./validation";
import 'vue-swatches/dist/vue-swatches.css'

Vue.use(BootstrapVue);
Vue.use(DashboardPlugin);
Vue.use(abilitiesPlugin, ability);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  i18n,
  localStorage
});
